const TRANSPORT_KEY = "EcoClubsForMissionLiFEAICTEADMIN1@1234SecretKey";

const textEncoder = new TextEncoder();

const toBase64 = (bytes) => {
  let binary = "";
  const chunkSize = 0x8000;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
  }
  return btoa(binary);
};

const deriveAesKey = async () => {
  const rawKey = await crypto.subtle.digest("SHA-256", textEncoder.encode(TRANSPORT_KEY));
  return crypto.subtle.importKey("raw", rawKey, { name: "AES-GCM" }, false, ["encrypt"]);
};

export const encryptPdfForTransport = async (file) => {
  if (!file || file.type !== "application/pdf") {
    throw new Error("Only PDF files are supported for transport encryption");
  }

  const key = await deriveAesKey();
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const plainBytes = await file.arrayBuffer();

  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    plainBytes
  );

  const encryptedFile = new File(
    [new Uint8Array(encryptedBuffer)],
    `${file.name}.encpdf`,
    { type: "application/octet-stream" }
  );

  return {
    encryptedFile,
    metadata: {
      transportEncrypted: "1",
      transportVersion: "v1",
      transportIv: toBase64(iv),
      transportOriginalMime: file.type,
      transportOriginalName: file.name,
    },
  };
};
